import React from 'react';

import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {AUTOGENERATED_NAME_TEXT} from 'studies/StudyConstants';
import {getProcedureRunUIStringForStudyType} from 'studies/TypedStudyUtils';
import FormGroup from 'ui-library/bs/FormGroup';
import TextField from 'ui-library/inputs/TextField';

export default function ExperimentNameField(props: {studyType: StudyType}): JSX.Element {
  return (
    <FormGroup>
      <TextField
        label={`${getProcedureRunUIStringForStudyType(props.studyType, {capital: true})} name`}
        placeholder={`New ${getProcedureRunUIStringForStudyType(props.studyType)} name`}
        isRequired={false}
        disabled={true}
        value={AUTOGENERATED_NAME_TEXT}
        dataTestAttrs={{component: 'AddExperimentModal', element: 'experimentNameInput'}}
      />
    </FormGroup>
  );
}
